import { SliderInput } from '../shared/SliderInput';
import type { HubV2State } from '../hooks/useHubV2State';

export default function StepOpslag({ state }: { state: HubV2State }) {
  const { bE, setBE, bP, setBP, eff, setEff, dod, setDod, deg, setDeg, projYear, setProjYear, effectiveBE, degPct } = state;

  return (
    <div className="space-y-4">
      <div className="p-5 bg-white rounded-xl border border-[#D9E2EC] shadow-sm">
        <div className="text-sm font-bold text-[#0B1F4A] mb-1">🔋 Batterij (BESS)</div>
        <div className="text-xs text-[#8899AA] mb-4">Configureer de batterijopslag capaciteit en parameters.</div>

        <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-2">
          <SliderInput label="BESS Energie" value={bE} set={setBE} min={0} max={100} step={0.5} unit="MWh" group="batt" tooltip="Totale batterijcapaciteit" />
          <SliderInput label="BESS Vermogen" value={bP} set={setBP} min={0} max={50} step={0.05} unit="MW" group="batt" tooltip="Max laad/ontlaadvermogen batterij" />
          <SliderInput label="Efficiency" value={eff} set={setEff} min={75} max={98} step={1} unit="%" group="batt" tooltip="Round-trip efficiency batterij" />
          <SliderInput label="DoD" value={dod} set={setDod} min={50} max={100} step={5} unit="%" group="batt" tooltip="Depth of Discharge — bruikbaar deel" />
          <SliderInput label="Degradatie" value={deg} set={setDeg} min={0} max={4} step={0.5} unit="%/j" group="batt" tooltip="Jaarlijks capaciteitsverlies batterij" />
          <SliderInput label="Projectjaar" value={projYear} set={setProjYear} min={1} max={20} step={1} unit="" group="batt" tooltip="Jaar in de levensduur (1=nieuw)" />
        </div>

        {/* Degradation info */}
        {projYear > 1 && (
          <div className="mt-3 px-3 py-2 rounded-lg border border-[#BFDBFE] bg-[#EFF6FF] text-[10px] text-[#3D4F6F]">
            📉 Na {projYear} jaar met {deg}% degradatie/jaar: <strong>{effectiveBE.toFixed(1)} MWh</strong> effectief ({degPct.toFixed(1)}% van origineel)
          </div>
        )}
      </div>
    </div>
  );
}
